"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var PageNavIcon = function PageNavIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M15,0H1C0.4,0,0,0.4,0,1v14c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V1C16,0.4,15.6,0,15,0z M8,12V9H4V7h4V4l4,4 L8,12z"
  })));
};
var _default = PageNavIcon;
exports["default"] = _default;